import axios from "axios";

export default async function fetchNetworkSetting() {
    const date = new Date().getTime();
    const url = `${process.env.NEXT_PUBLIC_NETWORKS_CDN}?date=${date}`;
    let result = null;
    const res = await axios({
        method: "get",
        url: url,
    });
    console.log("fetchNetworkSetting", res);
    if (res.status === 200) {
        result = res.data;
        return result;
    }
    return result;
}
